import { useEffect, useRef } from 'react'

import { useSearchParams } from 'react-router-dom'
import { useAppSelector, useAppDispatch } from 'shared/config/store'
import {
  setIsCreateTeamModalOpen,
  setIsJoinTeamModalOpen,
} from 'features/common/model/slice/appSlice'
import { userSelector } from 'features/user/model/selectors/userSelectors'
import { getFilesPreviewIsPublicLinkSelector } from 'features/files-preview/model/selectors/filesPreviewSelectors'

import { familySelector } from '../model/selectors/teamSelectors'

export const TeamModalManager = () => {
  const dispatch = useAppDispatch()
  const [searchParams] = useSearchParams()
  const userData = useAppSelector(userSelector)
  const familyCloud = useAppSelector(familySelector)
  const fchash = searchParams.get("fchash")
  const isPublicLink = useAppSelector(getFilesPreviewIsPublicLinkSelector)

  const hasRun = useRef(false)

  useEffect(() => {
    if (!userData || hasRun.current || (!!userData.family_user_id && !familyCloud?.id) || isPublicLink) return

    const isUserDataReady = 'family_user_id' in userData

    if (!isUserDataReady) return

    if (fchash === familyCloud?.invite_hash) {
      dispatch(setIsJoinTeamModalOpen(false))

      return
    }

    if (fchash) {
      dispatch(setIsJoinTeamModalOpen(true))
    } else if (!userData.family_user_id) {
      dispatch(setIsCreateTeamModalOpen(true))
    }

    hasRun.current = true
    
  }, [userData, searchParams, familyCloud, isPublicLink])

  return null
}
